import { requestApi } from "./axiosHelper";

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1";

const eventEP = rootUrl + "/event";

const eventAPI = {
  // ✅ Create a new event
  createNewEvent: async (obj) => {
    const axiosData = {
      url: `${eventEP}/create`,
      method: "post",
      data: obj,
    };
    try {
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Fetch all events or by ID
  fetchEvents: async (_id) => {
    try {
      const axiosData = {
        url: _id ? `${eventEP}/${_id}` : eventEP,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Fetch events by filters (category, type, date, etc.)
  fetchByFilters: async (params) => {
    try {
      const axiosData = {
        url: `${eventEP}?${params}`,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Update an event by ID
  updateEvent: async (_id, obj) => {
    try {
      const axiosData = {
        url: `${eventEP}/edit/${_id}`,
        method: "patch",
        data: obj,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Delete an event by ID
  deleteEvent: async (_id) => {
    try {
      const axiosData = {
        url: `${eventEP}/${_id}`,
        method: "delete",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Add gallery images after event ends
  // Add gallery images after event ends
  addGalleryImages: async (_id, { images, extendedDesc }) => {
    try {
      const axiosData = {
        url: `${eventEP}/${_id}/gallery`,
        method: "patch",
        data: { images, extendedDesc }, // send both
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },
};

export default eventAPI;
